namespace GeniuzPOS.ReportMasterData {
    export interface Report_1104Form {
        SupplName: Serenity.StringEditor;
        ShortName: Serenity.StringEditor;
        ContactName: Serenity.StringEditor;
        SupTelNo: Serenity.StringEditor;
        SupplRegName: Serenity.StringEditor;
        SupplTaxId: Serenity.LookupEditor;
        SupplAddress: Serenity.LookupEditor;
        SupplType: Serenity.IntegerEditor;
        ConsignFg: Serenity.LookupEditor;
    }

    export class Report_1104Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1104';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1104Form.init)  {
                Report_1104Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(Report_1104Form, [
                    'SupplName', w0,
                    'ShortName', w0,
                    'ContactName', w0,
                    'SupTelNo', w0,
                    'SupplRegName', w0,
                    'SupplTaxId', w1,
                    'SupplAddress', w1,
                    'SupplType', w2,
                    'ConsignFg', w1
                ]);
            }
        }
    }
}
